export default {
  setSelectedYear (state: {[key:string]: string}, value: string) {
    state.selectedYear = value
  },
  setSelectedSeason (state: {[key:string]: string}, value: string) {
    state.selectedSeason = value
  },
  setSelectedStatus (state: {[key:string]: any}, value: number[]) {
    state.selectedStatus = value
  },
  setSelectedVariety (state: {[key:string]: any}, value: string) {
    state.selectedVariety = value
  },
  setSelectedGrade (state: {[key:string]: any}, value: string) {
    state.selectedGrade = value
  },
  setSelectedExcludedArea (state: {[key:string]: any}, value: string) {
    state.selectedExcludedArea = value
  },
  setWord (state: {[key:string]: any}, value: string) {
    state.word = value
  },
  setCurrentPage (state: {[key:string]: any}, page: number) {
    state.currentPage = page
  },
  setOrderNum (state: {[key:string]: any}, order: number) {
    state.orderNum = order
  },
  setSort (state: {[key:string]: any}, sort: string) {
    state.sort = sort
  },
  setModalOrderNum (state: {[key:string]: any}, order: number) {
    state.modalOrderNum = order
  },
  setModalSort (state: {[key:string]: any}, sort: string) {
    state.modalSort = sort
  },
  setFileName (state: {[key:string]: any}, sort: string) {
    state.fileName = sort
  }
}
